import React, { useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { TbDragDrop } from 'react-icons/tb';
import { IoMdArrowRoundBack } from 'react-icons/io';

import * as S from './styles';
import DynamicPageContext from 'context/DynamicPage';

import Load from 'components/Load';
import OptionDynamicPage from 'components/OptionDynamicPage';

export default function DynamicPageOptionsList() {
	const navigate = useNavigate();
	const { slug } = useParams<{ slug: string }>();
	const { isLoad, dynamicPageSelected, listOptions } =
		useContext(DynamicPageContext);

	return (
		<S.container>
			{isLoad ? (
				<S.loadBox>
					<Load showText text="Carregando" />
				</S.loadBox>
			) : (
				<>
					<S.titleList>
						<S.nameDynamicPage>
							<IoMdArrowRoundBack onClick={() => navigate(-1)} />
							<h3>{dynamicPageSelected?.name || `sem dado de - ${slug}`}</h3>
						</S.nameDynamicPage>

						<S.iconAndDescription>
							<TbDragDrop />
							<p>
								<b>Arraste</b> um novo módulo até o preview do app ao lado e
								posicione no local desejado ou <b>clique 2 vezes</b> sobre o
								mesmo.
							</p>
						</S.iconAndDescription>
					</S.titleList>
					<S.boxListOptions>
						{listOptions.length === 0 ? (
							<S.noOptions>
								<p>Não há opções de páginas dinâmicas</p>
							</S.noOptions>
						) : (
							<>
								{listOptions.map((item) => (
									<OptionDynamicPage key={item.id} option={item} />
								))}
							</>
						)}
					</S.boxListOptions>
				</>
			)}
		</S.container>
	);
}
